<template>
    <div>
        <MenuBar/>
        <div class="contentOnNavBar">
            <SideMenu/>
            <div style="padding: 0.5rem; width: 100%">
                <div class="pageTitle">Lista de Catálogos</div>

                <div style="padding: 1rem 0 0.5rem 0; width: 100%;">
                    <button class="btn btn-success btn-sm" @click="$router.push({name: 'CatalogCreate'})">Novo Catálogo</button>
                    <button class="btn btn-danger btn-sm" style="float: right;" data-bs-toggle="modal" data-bs-target="#confirmDelete"
                            :disabled="selectedCatalogs.length == 0">Excluir Selecionados
                    </button>
                </div>

                <div id="no-more-tables">
                    <table class="table table-sm" style="padding-top: 0.5rem;" v-if="catalogs">
                        <thead>
                        <tr>
                            <th scope="col">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" @click="selectAllOrNone">
                                </div>
                            </th>
                            <th scope="col">Nome
                                <i class="fas fa-sort" v-if="!$refs.pagination.sortFieldsContainsField('name', null)" @click="$refs.pagination.addSortField('name')"></i>
                                <i class="fas fa-sort-up" v-if="$refs.pagination.sortFieldsContainsField('name', 'ASC')" @click="$refs.pagination.addSortField('name')"></i>
                                <i class="fas fa-sort-down" v-if="$refs.pagination.sortFieldsContainsField('name', 'DESC')" @click="$refs.pagination.addSortField('name')"></i>
                            </th>
                            <th scope="col">Link Público</th>
                            <th scope="col">Criado em
                                <i class="fas fa-sort" v-if="!$refs.pagination.sortFieldsContainsField('date', null)" @click="$refs.pagination.addSortField('date')"></i>
                                <i class="fas fa-sort-up" v-if="$refs.pagination.sortFieldsContainsField('date', 'ASC')" @click="$refs.pagination.addSortField('date')"></i>
                                <i class="fas fa-sort-down" v-if="$refs.pagination.sortFieldsContainsField('date', 'DESC')" @click="$refs.pagination.addSortField('date')"></i>
                            </th>
                            <th scope="col">Produtos</th>
                            <th scope="col">Visualizações</th>
                            <th scope="col">Ativo</th>
                            <th scope="col" style="width: 5.7rem">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(catalog, index) in catalogs" :key="index">
                            <td data-title="Selecionar" class="align-middle">
                                <div class="form-check">
                                    <input class="form-check-input" :value="catalog.id" type="checkbox" v-model="selectedCatalogs">
                                </div>
                            </td>
                            <td data-title="Nome" class="align-middle">{{ catalog.name }}</td>
                            <td data-title="Link Público" class="align-middle">{{ getCatalogUrl(catalog.id) }}</td>
                            <td data-title="Criado em" class="align-middle">{{ catalog.date | moment("DD/MM/YYYY HH:mm") }}</td>
                            <td data-title="Produtos" class="align-middle">{{ catalog.productsQuantity }}</td>
                            <td data-title="Visualizações" class="align-middle">{{ catalog.viewCount }}</td>
                            <td data-title="Ativo" class="align-middle">{{ catalog.active ? 'Sim' : 'Não' }}</td>
                            <td class="align-middle">
                                <div class="btn-group " role="group">
                                    <button id="btnGroupDrop1" type="button" class="btn btn-warning btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        Ações
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1" style="min-width: unset !important; padding: 0 !important">
                                        <li><a class="dropdown-item sm" @click="$router.push({name: 'CatalogViewInternal', query:{'id': catalog.id}})" style="cursor: pointer"> <i class="far fa-eye fa-sm" style="margin-right: 0.5rem"></i>Ver</a></li>
                                        <li><a class="dropdown-item sm" @click="$router.push({name: 'CatalogCreate', query:{'id': catalog.id}})" style="cursor: pointer"> <i class="fas fa-pen fa-sm" style="margin-right: 0.5rem"></i>Editar</a></li>
                                        <li><a class="dropdown-item sm" @click="$refs.shareDialog.urlToShare = $APP_URL + '/catalogView?id='+catalog.id" data-bs-toggle="modal" data-bs-target="#shareChooseDialog" style="cursor: pointer"><i class="fas fa-share-alt fa-sm" style="margin-right: 0.5rem"></i>Compartilhar</a></li>
                                        <li><a class="dropdown-item sm" @click="downloadPDF(catalog.id)" style="cursor: pointer"><i class="fas fa-file-download fa-sm" style="margin-right: 0.5rem"></i>Baixar PDF</a></li>
                                        <li><a class="dropdown-item sm" @click="selectedCatalogs = []; selectedCatalogs.push(catalog.id)" data-bs-toggle="modal" data-bs-target="#confirmDelete" style="cursor: pointer">
                                            <i class="fas fa-trash fa-sm" style="margin-right: 0.5rem"></i>Excluir</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <Pagination ref="pagination" v-on:page-clicked="(c) => this.catalogs = c" endpoint-list="/catalog/list/" endpoint-count="/catalog/count"/>
                <ConfirmDelete v-on:done="$refs.pagination.getObjects(-1)" :objects-to-exclude="selectedCatalogs"
                               :message="'Tem certeza que deseja excluir o catálogo selecionado?'" :endpoint="'/catalog'"/>
                <ShareChooseDialog ref="shareDialog"/>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import MenuBar from '../../template/MenuBar'
import SideMenu from '../../template/SideMenu'
import Footer from '../../template/Footer'
import Pagination from '@/components/pages/components/Pagination.vue'
import axios from "axios";
import ConfirmDelete from "@/components/pages/components/ConfirmDelete";
import ShareChooseDialog from "../components/ShareChooseDialog";

export default {
    components: {
        ShareChooseDialog,
        ConfirmDelete,
        MenuBar,
        SideMenu,
        Footer,
        Pagination,
    },

    data: function () {
        return {
            catalogs: null,
            selectedCatalogs: []
        }
    },

    mounted() {
        if (axios.defaults.headers.common["Authorization"] == undefined || axios.defaults.headers.common["Authorization"] == '') {
            this.$router.push({name: 'Index'})
        }
    },

    methods: {
        downloadPDF(catalogId) {
            let headers = {}
            headers.Authorization = axios.defaults.headers.common["Authorization"]
            headers.responseType = 'blob'
            axios.get(this.$API_ADDRESS + '/catalog/catalogPdf/' + catalogId, headers)
                .then(response => {
                    let blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    window.open(window.URL.createObjectURL(blob));
                })
        },

        selectAllOrNone() {
            if (this.selectedCatalogs.length > 0) {
                this.selectedCatalogs = []
            } else {
                this.selectedCatalogs = []
                this.catalogs.forEach(c => {
                    this.selectedCatalogs.push(c.id)
                })
            }
        },

        getCatalogUrl: function (id) {
            return 'https://www.newspirit.com.br/catalogView?id=' + id;
        },
    }

}
</script>

<style scoped>
</style>